import { gql } from '@apollo/client';

export const ADD_VIDEO_MEDIA = gql`
  mutation addVideoMedia($input: VideoMediaInput!) {
    addVideoMedia(input: $input) {
      mediaId
      message
    }
  }
`;

export type AdditionalImageInput = {
  maAdditionalImagesS3KeyUrl: string;
  maAdditionalImagesLabelId: string;
  maAdditionalImagesLabelName: string;
  maAdditionalImagesLabelValue: string;
  maIsThumbnail: boolean;
};

export type VideoMediaInput = {
  maTitle: string;
  maDescription?: string;
  maType: 'VIDEOS';
  maTags: string[];
  genreIds: string[];
  ageRatingId: string;
  maS3MediaKeyUrl: string;
  maS3ThumbnailKeyUrl: string;
  maAdditionalImages: AdditionalImageInput[];
  maDuration?: string;
};

export type AddVideoMediaData = {
  addVideoMedia: {
    mediaId: string;
    message: string;
  };
};

export const EDIT_VIDEO_MEDIA = gql`
  mutation editVideoMedia($input: EditVideoMediaInput!) {
    editVideoMedia(input: $input) {
      mediaId
      message
    }
  }
`;

export type EditVideoMediaInput = {
  maId: string;
  maTitle?: string;
  maDescription?: string;
  maTags?: string[];
  genreIds?: string[];
  ageRatingId?: string;
  maS3ThumbnailKeyUrl?: string;
  maAdditionalImages?: AdditionalImageInput[];
  maDuration?: string;
};

export type EditVideoMediaData = {
  editVideoMedia: {
    mediaId: string;
    message: string;
  };
};
